<template>
  <div class="space-y-8">
    <section class="bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-xl shadow-slate-200/50">
      <!-- HEADER -->
      <div class="px-8 py-5 flex flex-wrap items-center justify-between gap-6" style="background-color: #333333;">
          <div class="flex items-center gap-4">
            <div class="p-2 bg-orange-500/10 rounded-lg">
              <v-icon color="orange" small>mdi-cash-multiple</v-icon>
            </div>
            <h2 class="text-white font-black uppercase tracking-[0.2em] text-[11px]">Dotações Orçamentárias</h2>
          </div>
          
          <div class="flex items-center gap-6 flex-1 justify-end max-w-2xl">
            <v-text-field
              v-model="search"
              placeholder="PESQUISAR DOTAÇÃO..."
              solo flat dense hide-details
              class="custom-field-dark bg-white/10 rounded-2xl w-full max-w-xs"
              prepend-inner-icon="mdi-magnify"
            />
            <button 
              @click="$router.push(`/biddings-donnations/create/${bidding_id}/${prefecture_id}`)"
              class="bg-orange-500 hover:bg-orange-600 text-white font-black text-[10px] px-8 h-12 rounded-xl shadow-xl transition-all flex items-center gap-3 uppercase tracking-widest group active:scale-95"
            >
              <v-icon color="white" size="18" class="group-hover:rotate-90 transition-transform">mdi-plus</v-icon>
              <span>Adicionar Dotação</span>
            </button>
          </div>
      </div>

      <div class="p-0">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :items-per-page="10"
            :loading="loader"
            loading-text="Sincronizando dotações orçamentárias..."
            class="premium-table"
            hide-default-footer
          >
            <template v-slot:item.bidding_process_number="{ item }">
              <span class="text-[10px] font-black text-slate-400 font-mono tracking-widest bg-slate-50 px-2 py-1 rounded">#{{ item.bidding_process_number }}</span>
            </template>

            <template v-slot:item.sec_name="{ item }">
              <span class="text-xs font-black text-slate-700 uppercase tracking-tight">{{ item.sec_name }}</span>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <div class="flex justify-end gap-2 px-4">
                <v-btn 
                  icon small 
                  class="hover:bg-orange-50 group" 
                  @click="$router.push(`/biddings-donnations/edit/${item.bugget_donation_id}/${prefecture_id}`)"
                  title="Editar"
                >
                  <v-icon size="18" color="orange" class="group-hover:scale-110 transition-transform">mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn 
                  icon small 
                  class="hover:bg-red-50 group" 
                  @click="deleteItem(item.bugget_donation_id)"
                  title="Excluir"
                >
                  <v-icon size="18" color="red" class="group-hover:scale-110 transition-transform">mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:no-data>
              <div class="py-20 flex flex-col items-center justify-center text-slate-300">
                <div class="p-6 bg-slate-50 rounded-full mb-4">
                  <v-icon size="64" color="slate-100">mdi-cash-remove</v-icon>
                </div>
                <p class="text-xs font-black uppercase tracking-[0.2em]">Nenhuma dotação vinculada</p>
              </div>
            </template>
          </v-data-table>
      </div>
    </section>

    <!-- Snackbar / Notificações -->
    <v-snackbar
      v-model="snack.show"
      :color="snack.color"
      timeout="4000"
      top
      elevation="24"
      class="custom-snack"
    >
      <div class="flex items-center gap-3">
        <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-xs font-black uppercase tracking-widest">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["bidding_id", "prefecture_id"],
  data: () => ({
    search: "",
    loader: true,
    data: [],
    snack: { show: false, message: "", color: "" },
    headers: [
      { text: "Licitação", value: "bidding_process_number", align: "start" },
      { text: "Setor Responsável", value: "sec_name", align: "start" },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/biddings/donnations/${this.bidding_id}`)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", false);
        });
    },
    deleteItem(id) {
      if (confirm("Deseja excluir este registro de dotação?")) {
        this.$store.dispatch("setLoader", true);
        this.$http.delete(`/biddings/donnations/${id}`)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.premium-table ::v-deep table { 
  background-color: transparent !important; 
  border-collapse: separate; 
  border-spacing: 0; 
}

.premium-table ::v-deep th { 
  color: #94a3b8 !important; 
  font-weight: 900 !important; 
  text-transform: uppercase !important; 
  font-size: 10px !important; 
  letter-spacing: 0.15em !important;
  background-color: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  height: 64px !important;
  padding: 0 32px !important;
}

.premium-table ::v-deep td { 
  border-bottom: 1px solid #f8fafc !important;
  color: #334155 !important;
  padding: 12px 32px !important;
}

.premium-table ::v-deep tr:hover {
  background-color: #fcfcfc !important;
}

.custom-field-dark >>> .v-input__control .v-input__slot {
  background: transparent !important;
  font-size: 11px !important;
  font-weight: 900 !important;
  color: #ffffff !important;
  padding: 0 16px !important;
}

.custom-field-dark >>> input {
  color: #ffffff !important;
  text-transform: uppercase;
}

.custom-snack >>> .v-snack__wrapper {
  border-radius: 1.25rem !important;
}
</style>